module.exports = __webpack_public_path__ + "img/info_circle.cda309ec.svg";